import { render, staticRenderFns } from "./ModuleImport.vue?vue&type=template&id=288e347a"
import script from "./ModuleImport.vue?vue&type=script&lang=js"
export * from "./ModuleImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports